export function formatMoney(value: unknown, currency?: string | null) {
    if (value == null) return '—';

    let n: number;
    if (typeof value === 'number') n = value;
    else if (typeof value === 'string') n = Number(value);
    else n = Number((value as any)?.toString?.() ?? value);

    if (!Number.isFinite(n)) return '—';

    const curr = currency ?? undefined; // null → undefined로 정규화
    if (!curr) return n.toLocaleString();

    // Intl은 잘못된 통화코드면 에러를 던지니 안전하게 try/catch
    try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: curr }).format(n);
    } catch {
        return `${n.toLocaleString()} ${curr}`.trim();
    }
}

/**
 * 가중치(weight)를 입력하는 경우 string -> 데이터베이스 Decimal 변환 필요
 */
export function toNumberOrNull(value: string | number | null | undefined) {
    if (value == null) return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    
    const string = value.trim();
    if (string === '') return null;

    const number = Number(string);

    return Number.isFinite(number) ? number : null;
}
